// ############### Hierarchical Category Helpers (Universal) ###############

// ##### Key Construction #####
export function buildL0Key(l0Name, type) {
  return `${l0Name}_${type}`;
}

export function buildL1Key(l0Name, type, l1Name) {
  return `${l0Name}_${type}_${l1Name}`;
}

// ##### Key Extraction #####
export function extractL0Name(key) {
  if (!key) return '';
  return key.replace(/_In$|_Out$/, '').split('_')[0];
}

export function extractType(key) {
  if (!key) return null;
  if (key.endsWith('_In')) return 'In';
  if (key.endsWith('_Out')) return 'Out';
  return null;
}

export function extractL1Name(l1Key) {
  if (!l1Key) return '';
  const parts = l1Key.split('_');
  if (parts.length < 3) return '';
  return parts.slice(2).join('_');
}

// ##### Get Options #####
export function getL0Options(tree, filterType = null) {
  if (!tree?.by_l0) return [];
  let options = Object.entries(tree.by_l0).map(([id, obj]) => ({ value: id, label: obj.name }));
  
  if (filterType) {
    options = options.filter(opt => opt.value.endsWith(`_${filterType}`));
  }
  
  return options;
}

export function getL1Options(tree, l0Id) {
  if (!tree?.by_l0 || !l0Id) return [];
  const l0 = tree.by_l0[l0Id];
  if (!l0?.children) return [];
  return l0.children.map(l1Id => {
    const l1 = tree.by_l1?.[l1Id];
    return l1 ? { value: l1Id, label: l1.name } : null;
  }).filter(Boolean);
}

export function getL2Options(tree, l1Id) {
  if (!tree?.by_l1 || !l1Id) return [];
  const l1 = tree.by_l1[l1Id];
  if (!l1?.children) return [];
  return l1.children.map(l2Id => {
    const l2 = tree.by_l2?.[l2Id];
    return l2 ? { value: l2Id, label: l2.name } : null;
  }).filter(Boolean);
}
